import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import StartSession from "@/pages/StartSession";
import Simulator from "@/pages/Simulator";
import Leaderboard from "@/pages/Leaderboard";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<StartSession />} />
        <Route path="/simulator/:sessionId" element={<Simulator />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
